let language = {
    PRODUCT_DESIGN_EDITER_MV_NAV_LOADING_ISSUE_TITLE: "加载产品定制步骤失败 ",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT: "我们在加载定制步骤时遇到了一个问题。 您想回到上一步吗？",
    
}
export { language }